import { REPORT_ERRORS } from 'constants/reportErrorMessages.js';

/* Array Utils */
export const getSingleElementFromId = (id, elementArrays = []) => elementArrays.find(el => el.public_id === id);

export const getElementsFromIds = (idArrays = [], elementArrays = []) => idArrays.map(statObject => ({
  ...statObject, ...elementArrays.find(el => el.public_id === statObject.public_id),
}));

/* Map Utils */
export const createKeyMap = (dataArray = [], key) => {
  const map = {};
  dataArray.forEach((item) => {
    const itemKey = item[key];
    map[itemKey] = map[itemKey] || item; // same or initialize
  });
  return map;
};

/* Error Utils */
export const validateErrorState = section => {
  if (section.error && section.error.type) {
    return REPORT_ERRORS[section.error.type] || section.error;
  }
  return null;
};

export const getSingleElementFromIdMap = (id, map = {}) => map[id] || {};

export const getElementsFromIdsMap = (idArrays = [], map = {}) => idArrays.map(statObject => ({
  ...statObject, ...map[statObject.public_id],
}));

/* Array implementation of formatting. Is slower than formatReportWithMap below */
// export const formatReport = (action = {}) => {
//   const { data } = action;
//   const { entities, content_pieces, content, social, keywords } = data;
//   const entityType = data.request.report_type;
//   const reverseEntity = entityType === 'brand' ? 'publisher' : 'brand';

//   const reverseEntityDataKey = `${reverseEntity}s`;
//   const commonEntitiesDataKey = `${entityType}s_by_common_${reverseEntity}s`; // example: brands_by_common_publishers
//   const topEntityByReverseDataKey = `top_${reverseEntity}s_by_${entityType}s`; // example: top_publishers_by_brands
//   const topEntityNumContentDataKey = `top_${reverseEntity}s_by_num_contents`; // example: top_publishers_by_num_content

//   const formattedReport = {
//     entities,
//     public_id: data.public_id,
//     request: data.request,
//     /* Content Mappings */
//     content: {
//       top_entities_by_num_contents: getElementsFromIds(content.top_entities_by_num_contents, entities),
//       entities_by_num_contents: getElementsFromIds(content.entities_by_num_contents, entities),
//       entities_by_num_articles: getElementsFromIds(content.entities_by_num_articles, entities),
//       entities_by_num_videos: getElementsFromIds(content.entities_by_num_videos, entities),
//       entities_by_word_count: getElementsFromIds(content.entities_by_word_count, entities),
//       entities_by_reading_time: getElementsFromIds(content.entities_by_reading_time, entities),
//       entities_timeseries: content.entities_timeseries,
//     },
//     /* Social Mappings */
//     social: {
//       top_entities_by_num_shares: social.top_entities_by_num_shares.map(({ entity, num_in_common }) => ({
//         entity: getSingleElementFromId(entity, entities),
//         num_in_common,
//       })),
//       entities_by_num_shares: getElementsFromIds(social.entities_by_num_shares, entities),
//       top_content_by_shares: getElementsFromIds(social.top_content_by_shares, content_pieces),
//       top_content_by_entities: social.top_content_by_entities.map(({ entity, resources, top_content }) => ({
//         entity: getSingleElementFromId(entity, entities),
//         resources: getElementsFromIds(resources, content_pieces),
//         top_content: getSingleElementFromId(top_content, content_pieces),
//       })),
//     },
//     /* Keyword Mappings */
//     keywords: {
//       top_keywords_by_num_contents: keywords.top_keywords_by_num_contents,
//       entities_by_common_keywords: keywords.entities_by_common_keywords.map(({ keyword, resources }) => ({
//         keyword,
//         resources: getElementsFromIds(resources, entities),
//       })),
//       top_keywords_by_entity: keywords.top_keywords_by_entity.map(({ entity, resources, top_content }) => ({
//         entity: getSingleElementFromId(entity, entities),
//         resources,
//         top_content: getSingleElementFromId(top_content, content_pieces),
//       })),
//     },
//     /* Publisher / Brand [Reverse reportType] Mappings */
//     [reverseEntityDataKey]: {
//       [commonEntitiesDataKey]: data[reverseEntityDataKey][commonEntitiesDataKey].map(({ public_id, resources }) => ({
//         entity: getSingleElementFromId(public_id, entities),
//         resources: getElementsFromIds(resources, entities),
//       })),
//       [topEntityByReverseDataKey]: data[reverseEntityDataKey][topEntityByReverseDataKey].map(({ entity, resources, top_content }) => ({
//         entity: getSingleElementFromId(entity, entities),
//         resources: getElementsFromIds(resources, entities),
//         top_content: getSingleElementFromId(top_content, content_pieces),
//       })),
//       [topEntityNumContentDataKey]: getElementsFromIds(data[reverseEntityDataKey][topEntityNumContentDataKey], entities),
//     },
//   };

//   return { data: formattedReport, status: 'success' };
// };

/* In use. Map implementation of formatting. */
export const formatReportWithMap = (action = {}) => {
  const { data } = action;
  // console.log('zzz action', action)
  if (action.status && (action.status === 'error' || action.status === 'not found')) {
    return action;
  }

  const { entities, content_pieces, content, social, keywords } = data;
  const entityType = data.request.report_type;
  const reverseEntity = entityType === 'brand' ? 'publisher' : 'brand';

  const entitiesMap = createKeyMap(entities, 'public_id');
  const contentsMap = createKeyMap(content_pieces, 'public_id');

  const reverseEntityDataKey = `${reverseEntity}s`;
  const commonEntitiesDataKey = `${entityType}s_by_common_${reverseEntity}s`; // example: brands_by_common_publishers
  const topEntityByReverseDataKey = `top_${reverseEntity}s_by_${entityType}s`; // example: top_publishers_by_brands
  const topEntityNumContentDataKey = `top_${reverseEntity}s_by_num_contents`; // example: top_publishers_by_num_content

  const formattedReport = {
    entities,
    public_id: data.public_id,
    request: data.request,
    /* Content Mappings */
    content: {
      ...{ error: validateErrorState(content) },
      top_entities_by_num_contents: getElementsFromIdsMap(content.top_entities_by_num_contents, entitiesMap),
      entities_by_num_contents: getElementsFromIdsMap(content.entities_by_num_contents, entitiesMap),
      entities_by_num_articles: getElementsFromIdsMap(content.entities_by_num_articles, entitiesMap),
      entities_by_num_videos: getElementsFromIdsMap(content.entities_by_num_videos, entitiesMap),
      entities_by_word_count: getElementsFromIdsMap(content.entities_by_word_count, entitiesMap),
      entities_by_reading_time: getElementsFromIdsMap(content.entities_by_reading_time, entitiesMap),
      entities_timeseries: content.entities_timeseries,
    },
    /* Social Mappings */
    social: {
      ...{ error: validateErrorState(social) },
      top_entities_by_num_shares: getElementsFromIdsMap(social.top_entities_by_num_shares, entitiesMap),
      entities_by_num_shares: getElementsFromIdsMap(social.entities_by_num_shares, entitiesMap),
      top_content_by_shares: getElementsFromIdsMap(social.top_content_by_shares, contentsMap),
      top_content_by_entities: social.top_content_by_entities.map(({ entity, resources, top_content }) => ({
        entity: getSingleElementFromIdMap(entity, entitiesMap),
        resources: getElementsFromIdsMap(resources, contentsMap),
        top_content: getSingleElementFromIdMap(top_content, contentsMap),
      })),
    },
    /* Keyword Mappings */
    keywords: {
      ...{ error: validateErrorState(keywords) },
      top_keywords_by_num_contents: keywords.top_keywords_by_num_contents,
      entities_by_common_keywords: keywords.entities_by_common_keywords.map(({ keyword, resources }) => ({
        keyword,
        resources: getElementsFromIdsMap(resources, entitiesMap),
      })),
      top_keywords_by_entity: keywords.top_keywords_by_entity.map(({ entity, resources, top_content }) => ({
        entity: getSingleElementFromIdMap(entity, entitiesMap),
        resources,
        top_content: getSingleElementFromIdMap(top_content, contentsMap),
      })),
    },
    /* Publisher / Brand [Reverse reportType] Mappings */
    [reverseEntityDataKey]: {
      ...{ error: validateErrorState(data[reverseEntityDataKey]) },
      [commonEntitiesDataKey]: data[reverseEntityDataKey][commonEntitiesDataKey].map(({ public_id, resources }) => ({
        entity: getSingleElementFromIdMap(public_id, entitiesMap),
        resources: getElementsFromIdsMap(resources, entitiesMap),
      })),
      [topEntityByReverseDataKey]: data[reverseEntityDataKey][topEntityByReverseDataKey].map(({ entity, resources, top_content }) => ({
        entity: getSingleElementFromIdMap(entity, entitiesMap),
        resources: getElementsFromIdsMap(resources, entitiesMap),
        top_content: getSingleElementFromIdMap(top_content, contentsMap),
      })),
      [topEntityNumContentDataKey]: getElementsFromIdsMap(data[reverseEntityDataKey][topEntityNumContentDataKey], entitiesMap),
    },
  };

  return { data: formattedReport, status: 'success' };
};
